import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$orgId/products/add-ons/')({
  loader: ({ params }) => {
    throw redirect({
      to: '/$orgId/products',
      params: { orgId: params.orgId },
      replace: true,
    })
  },
})
